import React from 'react';

/** A pet's face wearing a little top hat: other players' dressed-up pets. */
export default function DressedPetIcon({ size = 24, color = 'currentColor', className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      {/* Head, with ears, blocky like the voxel pets */}
      <path d="M5 11.5 5.8 7.8 8.4 10h7.2l2.6-2.2.8 3.7v5a3.5 3.5 0 0 1-3.5 3.5h-7A3.5 3.5 0 0 1 5 16.5v-5Z"
            fill={color} opacity="0.15" />
      <path d="M5 11.5 5.8 7.8 8.4 10h7.2l2.6-2.2.8 3.7v5a3.5 3.5 0 0 1-3.5 3.5h-7A3.5 3.5 0 0 1 5 16.5v-5Z"
            stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
      {/* Big sparkly eyes */}
      <circle cx="9.3" cy="14" r="1.3" fill={color} />
      <circle cx="14.7" cy="14" r="1.3" fill={color} />
      <circle cx="9.7" cy="13.6" r="0.4" fill="#fff" />
      <circle cx="15.1" cy="13.6" r="0.4" fill="#fff" />
      <path d="M11 16.8c.6.5 1.4.5 2 0" stroke={color} strokeWidth="1.2" strokeLinecap="round" />
      {/* Top hat, tipped */}
      <g transform="rotate(-12 12 6)">
        <rect x="9.5" y="2" width="5" height="4.2" rx="0.6" fill={color} />
        <rect x="8" y="6" width="8" height="1.4" rx="0.7" fill={color} />
      </g>
      <path d="M20 3.2l.5 1.2 1.2.5-1.2.5-.5 1.2-.5-1.2-1.2-.5 1.2-.5z" fill={color} opacity="0.7" />
    </svg>
  );
}
